import sortBy from 'lodash/sortBy';
import moment from 'moment-timezone';
import { getCurrentDayFlag, getDayFlag } from '../util/timeHelper';
import {
  detectMergeRequired,
  getItemPriceForSpecialDiscount,
  getSpecialDetectionCount,
} from './utilities';

// const someFunction = (f) => {};

export const calculateSpecialDiscountForSpecificItem = (specialObj, item) => {
  let specialsDiscountsList = [];
  let specialSpecificDiscount = 0;
  specialObj.rowItems.forEach((rowItem) => {
    if (rowItem.specialId) {
      const noOfSpecialDeal = specialObj.specials.filter(
        (item) => item._id === rowItem.specialId
      ).length;
      const noOfItemswithSameSpecialCategory =
        specialObj.rowItems.filter(
          (item) => item.specialId === rowItem.specialId
        ).length / noOfSpecialDeal;

      const specialDiscountsWithSameId = specialObj.specials.filter(
        (special) => special._id === rowItem.specialId
      );
      const discount =
        specialDiscountsWithSameId.reduce(
          (prevDiscount, currItem) => prevDiscount + Number(currItem.discount),
          0
        ) / specialDiscountsWithSameId.length;

      const alreadyAddedItem = specialsDiscountsList.find(
        (specialItem) =>
          specialItem.menuItemId === rowItem._id &&
          specialItem.specialId === rowItem.specialId
      );

      if (typeof alreadyAddedItem === 'object') {
        const objIndex = specialsDiscountsList.findIndex(
          (item) => item.menuItemId === rowItem._id
        );
        specialsDiscountsList[objIndex].discountPerItem = (
          Number(specialsDiscountsList[objIndex].discountPerItem) +
          Number(discount) / noOfItemswithSameSpecialCategory
        ).toFixed(2);
      } else {
        specialsDiscountsList = [
          ...specialsDiscountsList,
          {
            menuItemId: rowItem._id,
            specialId: rowItem.specialId,
            discountPerItem: (
              Number(discount) / noOfItemswithSameSpecialCategory
            ).toFixed(2),
          },
        ];
      }
    }
  });

  const specialItemDetail = specialsDiscountsList.find(
    (specialItem) => specialItem.menuItemId === item._id
  );
  if (typeof specialItemDetail === 'object') {
    specialSpecificDiscount = Number(specialItemDetail.discountPerItem);
  }

  return specialSpecificDiscount.toFixed(2);
};

export const detectSpecial = (
  currentOrder,
  rowItems,
  allSpecials,
  orderSetup,
  publicHolidays,
  storeConfig = {},
  preferredSpecialId
) => {
  window.itemsUsed = [];

  const specialItemsObj = [];
  let specialObj = { specials: [] };
  let specialFrames = getSpecialFrames(
    currentOrder,
    allSpecials,
    orderSetup,
    publicHolidays,
    storeConfig
  );
  if (rowItems?.length && specialFrames?.length) {
    let specialFramesType = specialFrames;

    const preferredSpecialIds = rowItems
      .map((rowItem) => rowItem.specialId)
      .filter((id) => Boolean(id));

    if (preferredSpecialId) {
      preferredSpecialIds.push(preferredSpecialId);
    }

    const uniquePreferredSpecialIds = new Set(preferredSpecialIds);

    if (preferredSpecialIds.length > 0) {
      uniquePreferredSpecialIds.forEach((sId) => {
        const preferredSpecialFrameType = specialFramesType.find(
          (s) => s._id === sId
        );
        getSpecialDetectionCount(
          preferredSpecialFrameType,
          rowItems,
          0,
          specialItemsObj,
          orderSetup?.isSpecialsManuallyDisabled,
          orderSetup?.autoDetectSpecialsWeb
        );
      });
    }

    if (!specialItemsObj || specialItemsObj.length === 0) {
      specialFramesType = sortBy(specialFramesType, 'slotLength').reverse();
      specialFramesType.forEach((s) => {
        getSpecialDetectionCount(
          s,
          rowItems,
          0,
          specialItemsObj,
          orderSetup?.isSpecialsManuallyDisabled,
          orderSetup?.autoDetectSpecialsWeb
        );
      });
    }

    if (specialItemsObj.length === 0) {
      specialFramesType = sortBy(specialFramesType, 'slotLength').reverse();
      specialFramesType.forEach((s) => {
        getSpecialDetectionCount(
          s,
          rowItems,
          0,
          specialItemsObj,
          orderSetup?.isSpecialsManuallyDisabled,
          orderSetup?.autoDetectSpecialsWeb
        );
      });
    }

    if (specialItemsObj?.length) {
      specialItemsObj.forEach((sd) => {
        let finalSpecial = sd;
        let itemsToBeAddedInSpecials = [];
        finalSpecial.slots.forEach((ss) => {
          let rowMenuItems = JSON.parse(JSON.stringify(currentOrder.menuItems));
          let filteredItem = [];
          const shouldApplySpecialDiscount = !orderSetup?.autoDetectSpecialsWeb;
          if (ss.isHalf) {
            filteredItem = rowMenuItems.filter((ff) => {
              const condition =
                ff._id === ss.itemId &&
                ff.isSecondHalf === false &&
                ff.orderIndex === ss.orderIndex;

              return shouldApplySpecialDiscount
                ? ff.specialId && condition
                : condition;
            });
          } else {
            filteredItem = rowMenuItems.filter((ff) => {
              const condition =
                ff._id === ss.itemId && ff.orderIndex === ss.orderIndex;
              return shouldApplySpecialDiscount
                ? ff.specialId && condition
                : condition;
            });
          }
          if (filteredItem?.length) {
            filteredItem.forEach((ftmm) => {
              let ttml = ftmm;
              if (detectMergeRequired(ss, ttml, true)) {
                ttml.selectedSizes = ttml.selectedSizes.filter(
                  (ggm) => ss.sizeKeyMatched === ggm._id
                );
                if (ttml.selectedSizes?.length) {
                  if (ttml.isHalf) {
                    ttml.selectedSizes[0].quantity = 0.5;
                  } else if (ttml.isQuarter) {
                    ttml.selectedSizes[0].quantity = 0.25;
                  } else {
                    ttml.selectedSizes[0].quantity = 1;
                  }
                  if (ttml.isHalf || ttml.isQuarter) {
                    let othersHalfOrFourQuarter = ttml.isHalf
                      ? rowMenuItems.filter(
                          (m) =>
                            m.halfIndex === ttml.halfIndex &&
                            m.isSecondHalf === true
                        )
                      : rowMenuItems.filter(
                          (m) =>
                            m.fourQuarterIndex === ttml.fourQuarterIndex &&
                            (m.isSecondQuarter === true ||
                              m.isThirdQuarter === true ||
                              m.isFourthQuarter === true)
                        );

                    /* ✅Caution✅ Need to compare git changes */
                    othersHalfOrFourQuarter?.forEach((others) => {
                      let ttmll = others;
                      if (ttml.selectedSizesHalfOrFourQuarter) {
                        ttml.selectedSizesHalfOrFourQuarter.push({
                          ...ttmll.selectedSizes[0],
                          quantity: ttml.isHalf ? 0.5 : 0.25,
                        });
                      } else {
                        ttml.selectedSizesHalfOrFourQuarter = [
                          {
                            ...ttmll.selectedSizes[0],
                            quantity: ttml.isHalf ? 0.5 : 0.25,
                          },
                        ];
                      }
                      if (ttml.selectedIngredientsHalfOrFourQuarter) {
                        ttml.selectedIngredientsHalfOrFourQuarter.push(
                          ttmll.selectedIngredients
                        );
                      } else {
                        ttml.selectedIngredientsHalfOrFourQuarter =
                          ttmll.selectedIngredients;
                      }
                      if (ttml.removedIngredientsHalfOrFourQuarter) {
                        ttml.removedIngredientsHalfOrFourQuarter.push(
                          ttmll.removedIngredients
                        );
                      } else {
                        ttml.removedIngredientsHalfOrFourQuarter =
                          ttmll.removedIngredients;
                      }
                      if (ttml.selectedExtraIngredientsHalfOrFourQuarter) {
                        ttml.selectedExtraIngredientsHalfOrFourQuarter.push(
                          ttmll.selectedExtraIngredients
                        );
                      } else {
                        ttml.selectedExtraIngredientsHalfOrFourQuarter =
                          ttmll.selectedExtraIngredients;
                      }
                    });

                    if (othersHalfOrFourQuarter[0]) {
                      ttml.otherHalfCategoryId =
                        othersHalfOrFourQuarter[0]?.categoryId;
                      ttml.otherHalfMenuItemId =
                        othersHalfOrFourQuarter[0]?._id;
                    }
                  }

                  ttml.isFreeItem = ss.isFreeItem;
                  ttml.discountedPrice = ss.discountedPrice;
                  itemsToBeAddedInSpecials.push(ttml);
                }
              }
            });
          }
          rowItems.forEach((rI) => {
            if (rI.primaryKey === ss.primaryKey) {
              rI.specialId = sd._id;
              rI.itemsUsedInSpecials = true;
            }
          });
        });

        let specialItems =
          allSpecials?.filter((obj) => obj._id === sd._id) ?? [];
        if (
          itemsToBeAddedInSpecials &&
          itemsToBeAddedInSpecials.length > 0 &&
          specialItems.length > 0
        ) {
          let specialItem = specialItems[0];
          let totalCost = 0,
            specialDiscount = 0,
            upsalePrice = 0;

          if (
            specialItem?.type === '2' &&
            specialItem?.chargeExpensiveItem &&
            itemsToBeAddedInSpecials?.length === 2
          ) {
            itemsToBeAddedInSpecials = itemsToBeAddedInSpecials.sort((a, b) => {
              return b.itemPrice - a.itemPrice;
            });

            if (itemsToBeAddedInSpecials[0]?.isFreeItem) {
              itemsToBeAddedInSpecials[0].isFreeItem = false;
              itemsToBeAddedInSpecials[1].isFreeItem = true;
            }
          }

          itemsToBeAddedInSpecials.forEach((m) => {
            if (specialItem.type === '1') {
              let itemPrice = getItemPriceForSpecialDiscount(m);
              let upsale = getUpsalePrice(m, specialItem);

              upsalePrice = upsalePrice + upsale;
              totalCost = totalCost + Number(itemPrice);
            } else {
              let itemPrice = getItemPriceForSpecialDiscount(m);
              let upsale = getUpsalePrice(m, specialItem);
              upsalePrice = upsalePrice + upsale;
              if (m.isFreeItem === true && m.discountedPrice === '0')
                specialDiscount = specialDiscount + Number(itemPrice);
              else if (m.isFreeItem === true && m.discountedPrice !== '0')
                specialDiscount =
                  specialDiscount +
                  (Number(itemPrice) - Number(m.discountedPrice));
              else totalCost = totalCost + Number(itemPrice);
            }
          });

          if (specialItem.type === '1' && totalCost >= specialItem.cost) {
            specialDiscount = totalCost - Number(specialItem.cost);
          }
          let sObj = {
            _id: specialItem._id,
            name: specialItem.name,
            discount: specialDiscount.toFixed(2),
            cost: specialItem.cost,
            type: specialItem.type,
            upsalePrice: upsalePrice.toFixed(2),
          };

          specialObj.specials.push(sObj);
        }
      });
    }
  }

  specialObj.rowItems = rowItems;
  return specialObj;
};

export function getUpsalePrice(menuItem, specialItem) {
  let upsalePrice = 0;
  if (
    specialItem.selectedCategories &&
    specialItem.selectedCategories.length > 0
  ) {
    specialItem.selectedCategories?.forEach((m) => {
      let matchedItem = null;
      let matchedItemOtherHalf = null;

      if (m.menuItems && m.menuItems.length > 0) {
        matchedItem = m.menuItems.find(
          (f) =>
            f._id === menuItem._id &&
            f.categoryId === menuItem.categoryId &&
            Number(f?.price) > 0 &&
            f.isActive === true
        );
        if (menuItem.isHalf) {
          matchedItemOtherHalf = m.menuItems.find(
            (f) =>
              f._id === menuItem.otherHalfMenuItemId &&
              f.categoryId === menuItem.otherHalfCategoryId &&
              Number(f?.price) > 0 &&
              f.isActive === true
          );
        }

        const matchedItemPrice = Number(matchedItem?.price || 0);
        const matchedItemOtherHalfPrice = Number(
          matchedItemOtherHalf?.price || 0
        );
        if (matchedItemPrice || matchedItemOtherHalfPrice)
          upsalePrice =
            matchedItemOtherHalfPrice >= matchedItemPrice
              ? matchedItemOtherHalfPrice
              : matchedItemPrice;
      }
    });
  }
  return upsalePrice;
}

export function getSpecialFrames(
  currentOrder,
  allSpecials,
  orderSetup,
  publicHolidays,
  storeConfig = {}
) {
  let specialFrames = [];
  if (allSpecials && allSpecials.length > 0) {
    let specials = allSpecials.filter(
      (f) =>
        f.orderFromKeys.includes(currentOrder.orderFrom) &&
        f.orderTypeKeys.includes(currentOrder.orderType) &&
        f.isPublished
    );
    specials.forEach((s) => {
      if (currentOrder.deliveryDate) {
        if (
          s.hasOwnProperty(
            getDayFlag(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
          ) &&
          s[
            getDayFlag(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm').dayText
          ] === true &&
          isSpecialAvaiableAllDay(
            s,
            currentOrder.deliveryDate,
            storeConfig.timeZone,
            currentOrder?.isFutureDeliveryDate
          ) &&
          isSpecialAvaiableOnPublicHoliday(
            s,
            currentOrder.deliveryDate,
            storeConfig.timeZone,
            orderSetup,
            publicHolidays,
            currentOrder?.isFutureDeliveryDate
          ) &&
          s.orderTypeKeys.includes(currentOrder.orderType)
        ) {
          let x = {
            _id: s._id,
            name: s.name,
            type: s.type,
            isAvailablePickup: s.isAvailablePickup ?? false,
            isAvailableDelivery: s.isAvailableDelivery ?? false,
            isComplete: false,
            slots: [],
          };

          s.selectedCategories?.forEach((sp) => {
            new Array(Number(sp.quantity)).fill().forEach((_m, i) => {
              let u = {
                categoryKeys: sp.categories
                  .filter((s) => s.isActive)
                  .map((s) => s._id),
                sizeKeys: sp.menuSizes
                  ? sp.menuSizes.filter((s) => s.isActive).map((s) => s._id)
                  : [],
                modifierKeys: sp.subModifiers
                  ? sp.subModifiers.filter((s) => s.isActive).map((s) => s._id)
                  : [],
                menuItems: sp.menuItems
                  .filter((s) => s.isActive)
                  .map((s) => s._id),
                id: i + 1,
                index: sp.isFreeItem ? i + 1 : -50,
                isSlotOccupied: false,
                isFreeItem: sp.isFreeItem,
                discountedPrice: sp.discountedPrice ? sp.discountedPrice : '0',
              };
              x.slots.push(u);
            });
          });
          x.slotLength = x.slots.length;
          specialFrames.push(x);
        }
      } else {
        if (
          s.hasOwnProperty(getCurrentDayFlag(storeConfig.timeZone).dayText) &&
          s[getCurrentDayFlag(storeConfig.timeZone).dayText] === true &&
          isSpecialAvaiableAllDay(
            s,
            undefined,
            storeConfig.timeZone,
            currentOrder?.isFutureDeliveryDate
          ) &&
          isSpecialAvaiableOnPublicHoliday(
            s,
            undefined,
            storeConfig.timeZone,
            orderSetup,
            publicHolidays,
            currentOrder?.isFutureDeliveryDate
          )
        ) {
          let x = {
            _id: s._id,
            name: s.name,
            type: s.type,
            isAvailablePickup: s.isAvailablePickup,
            isAvailableDelivery: s.isAvailableDelivery,
            isComplete: false,
            slots: [],
          };

          s.selectedCategories?.forEach((sp) => {
            new Array(Number(sp.quantity)).fill().forEach((_m, i) => {
              let u = {
                categoryKeys: sp.categories
                  .filter((s) => s.isActive)
                  .map((s) => s._id),
                sizeKeys: sp.menuSizes
                  ? sp.menuSizes.filter((s) => s.isActive).map((s) => s._id)
                  : [],
                modifierKeys: sp.subModifiers
                  ? sp.subModifiers.filter((s) => s.isActive).map((s) => s._id)
                  : [],
                menuItems: sp.menuItems
                  .filter((s) => !s.isActive)
                  .map((s) => s._id),
                id: i + 1,
                index: sp.isFreeItem ? i + 1 : -50,
                isSlotOccupied: false,
                isFreeItem: sp.isFreeItem,
                discountedPrice: sp.discountedPrice ? sp.discountedPrice : '0',
              };
              x.slots.push(u);
            });
          });
          x.slotLength = x.slots.length;
          specialFrames.push(x);
        }
      }
    });
  }
  return specialFrames;
}

export function isSpecialAvaiableAllDay(
  special,
  delDate,
  timeZone,
  isFutureDeliveryDate
) {
  if (special.isAvailableFullDay) return true;

  let currentMoment = moment.tz(timeZone);
  if (isFutureDeliveryDate && delDate) {
    currentMoment = moment.tz(delDate, timeZone);
  }

  // Get the time in seconds for the current day
  const currentTimeInSeconds =
    currentMoment.hours() * 3600 +
    currentMoment.minutes() * 60 +
    currentMoment.seconds();

  const { startTime, endTime } = special;

  // Compare current time in seconds with start and end time
  return currentTimeInSeconds >= startTime && currentTimeInSeconds <= endTime;
}

export function isSpecialAvaiableOnPublicHoliday(
  special,
  delDate,
  timeZone,
  orderSetup,
  publicHolidays,
  isFutureDeliveryDate
) {
  let todayDate = moment(
    moment().tz(timeZone).format('YYYY-MM-DD HH:mm'),
    'YYYY-MM-DD HH:mm'
  );
  if (isFutureDeliveryDate && delDate) {
    todayDate = moment(
      moment(delDate).tz(timeZone).format('YYYY-MM-DD HH:mm'),
      'YYYY-MM-DD HH:mm'
    );
  }
  if (
    orderSetup?.isOptedInForHolidaySurcharge &&
    orderSetup?.publicHolidaySurcharge &&
    publicHolidays?.length
  ) {
    let dateFound = publicHolidays.some(
      (m) => m === todayDate.format('YYYY-MM-DD')
    );
    if (dateFound && !special.isAvailablePublicHoliday) return false;
  }
  return true;
}

export function convertSecondsTo12Hour(timeStamp) {
  let hours = timeStamp / 3600;
  let minutes = (timeStamp / 60) % 60;
  let ampm = '';
  if (hours === 24) {
    hours = 23;
    minutes = 59;
  }
  hours >= 12 ? (ampm = 'PM') : (ampm = 'AM');
  return moment(`${hours}:${minutes} ${ampm}`, 'HH:mm A').format('HH:mm');
}
